<template>
  <div class="authority">
    <el-tree
      :disabled="disabled"
      ref="authorityTree"
      :data="authorityTree"
      show-checkbox
      node-key="id"
      :props="defaultProps">
      <!--@check-change="changeCheck"-->
      <!--:default-checked-keys="defaultSelect"-->
    </el-tree>
  </div>
</template>
<script>

  export default {
    name: 'authority',
    props: {
      authorityTree: {
        type: Array,
      },
      functionId: {
        type: String,
        default: '',
      },
      resourceId: {
        type: String,
        default: '',
      },
      disabled: {
        Boolean,
        default: false,
      },
    },
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        copySelect: [],
      };
    },
    computed: {
      defaultSelect() {
        let selectList = [];
        let selectObj = [];
        if (this.functionId) {
          selectList = this.functionId.split(',');
        }
        if (this.resourceId) {
          selectList = selectList.concat(this.resourceId.split(','));
        }
        selectObj = selectList.map(select => {
          return {
            id: select,
          };
        });
        return selectObj;
      },
    },
    watch: {
      defaultSelect: {
        handler(val, oldval) {
          this.$nextTick(() => {
            this.copySelect = JSON.parse(JSON.stringify(this.defaultSelect));
            this.transforTree(this.authorityTree);
            this.$refs.authorityTree.setCheckedNodes(this.copySelect);
          });
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      transforTree(authorityTree) {
        authorityTree.forEach(tree => {
          if (tree.children && tree.children.length > 0) {
            const parent = tree.children.every(child => this.defaultSelect.some(df => df.id === tree.id));
            if (parent) {
              this.copySelect = this.copySelect.filter(copy => tree.id !== copy.id);
            }
            this.transforTree(tree.children);
          }
        });
      },
      getCheckedNodes(value, value2) {
        return this.$refs.authorityTree.getCheckedNodes(value, value2);
      },
    },
  };
</script>
<style lang="scss">
  .authority {
    padding-top: 10px;
  }
</style>
